import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {State} from '../../../../reducers'
import {actionsGCListarClientes} from '../../../../actions/action-creators'
import '../styles/lista-cliente.css'

const LIFromFiltrosCliente = () => {
  const formClientes = useSelector((state: State) => state.gestionCliente.listarClientes.formBuscar)
  const arrayClientes = useSelector(
    (state: State) => state.gestionCliente.listarClientes.arrayClientes
  )
  const tiposDocumento = useSelector((state: State) => state.catalogos.tipoDocumento)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGCListarClientes, dispatch)

  useEffect(() => {
    if (
      !formClientes.nombre &&
      !formClientes.email &&
      !formClientes.telefono &&
      !formClientes.numId &&
      !formClientes.tipoDocumento &&
      arrayClientes.length > 0
    ) {
      acciones.gc_lc_BuscarCliente(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formClientes, arrayClientes])

  const limpiarFiltros = () => {
    acciones.gc_lc_FormBuscarHandleChange({
      target: {name: 'nombre', value: ''},
    } as unknown as React.ChangeEvent<HTMLInputElement>)
    acciones.gc_lc_FormBuscarHandleChange({
      target: {name: 'email', value: ''},
    } as unknown as React.ChangeEvent<HTMLInputElement>)
    acciones.gc_lc_FormBuscarHandleChange({
      target: {name: 'telefono', value: ''},
    } as unknown as React.ChangeEvent<HTMLInputElement>)
    acciones.gc_lc_FormBuscarHandleChange({
      target: {name: 'numId', value: ''},
    } as unknown as React.ChangeEvent<HTMLInputElement>)
    acciones.gc_lc_FormBuscarHandleChange({
      target: {name: 'tipoDocumento', value: ''},
    } as unknown as React.ChangeEvent<HTMLSelectElement>)
    acciones.gc_lc_BuscarCliente()
  }

  return (
    <form className='listar-cliente-form-filter-wrapper' onSubmit={(e) => e.preventDefault()}>
      <div className='listar-cliente-form-filter'>
        {/* Filtro por Nombre */}
        <div className='filter-field'>
          <label htmlFor='nombre' className='field-label m'>
            Nombre del cliente
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={250}
            name='nombre'
            placeholder='Nombre'
            onChange={acciones.gc_lc_FormBuscarHandleChange}
            value={formClientes.nombre}
          />
        </div>

        {/* Filtro por Email */}
        <div className='filter-field'>
          <label htmlFor='email' className='field-label m'>
            Correo electrónico
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={100}
            name='email'
            placeholder='Email'
            onChange={acciones.gc_lc_FormBuscarHandleChange}
            value={formClientes.email}
          />
        </div>

        {/* Filtro por Teléfono */}
        <div className='filter-field'>
          <label htmlFor='telefono' className='field-label m'>
            Teléfono
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={20}
            name='telefono'
            placeholder='Teléfono'
            onChange={acciones.gc_lc_FormBuscarHandleChange}
            value={formClientes.telefono}
          />
        </div>

        {/* Filtro por Tipo de Documento */}
        <div className='filter-field'>
          <label htmlFor='tipoDocumento' className='field-label m'>
            Tipo de documento
          </label>
          <select
            className='m text-field normal w-input'
            name='tipoDocumento'
            onChange={acciones.gc_lc_FormBuscarHandleChange}
            value={formClientes.tipoDocumento}
          >
            <option value=''>Todos</option>
            {tiposDocumento.map((tipo: any) => (
              <option key={tipo.codigo} value={tipo.codigo}>
                {tipo.valor}
              </option>
            ))}
          </select>
        </div>

        {/* Filtro por Número de documento */}
        <div className='filter-field'>
          <label htmlFor='numId' className='field-label m'>
            Número de documento
          </label>
          <input
            autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={20}
            name='numId'
            placeholder='Nº Documento'
            onChange={acciones.gc_lc_FormBuscarHandleChange}
            value={formClientes.numId}
          />
        </div>

        <div style={{display: 'flex', gap: '6px', alignItems: 'flex-end'}}>
          <button type='button' className='m button transparent filter-clear-btn' onClick={limpiarFiltros}>
            Limpiar filtros
          </button>
        </div>
      </div>
    </form>
  )
}

export default LIFromFiltrosCliente
